import axios from 'axios';
import { DEX } from '@/lib/types/hypertrackerTypes';
import { installSentryAxiosInterceptor } from '@/lib/sentry/sentryInterceptor';

const axiosInstance = axios.create({
    baseURL: 'https://api.hyperliquid.xyz/info',
    timeout: 45 * 1000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

installSentryAxiosInterceptor(axiosInstance, true);

export const fetchHyperLiquidData = (payload: { type: string; user?: string; dex?: DEX }) =>
    axiosInstance.post('', payload);

export const fetchVaultHyperLiquidData = (payload: { type: string; vaultAddress: string }) =>
    axiosInstance.post('', payload);

export const fetchVolumeData = (payload: { type: string }) => axiosInstance.post('', payload);

// AlphaFeed trading passes absolute testnet/mainnet URLs (backend `trading/config` network);
// axios ignores `baseURL` for absolute URLs, so the same instance serves both networks.
export const postHyperliquidInfoAt = <T>(
    infoUrl: string,
    payload: Record<string, unknown>,
    signal?: AbortSignal,
) => axiosInstance.post<T>(infoUrl, payload, { signal });

export interface HyperliquidExchangeResponse {
    status?: string;
    response?: unknown;
}

export const postHyperliquidExchange = (exchangeUrl: string, body: Record<string, unknown>) =>
    axiosInstance.post<HyperliquidExchangeResponse>(exchangeUrl, body);

export const fetchHlCandleSnapshot = (payload: {
    coin: string;
    interval: string;
    startTime: number;
    endTime: number;
}) => axiosInstance.post<HlCandleRaw[]>('', { type: 'candleSnapshot', req: payload });

export interface HlCandleSnapshotPayload {
    coin: string;
    interval: string;
    startTime: number;
    endTime: number;
}

export interface HlCandleRaw {
    T: number;
    t: number;
    s: string;
    i: string;
    o: string;
    c: string;
    h: string;
    l: string;
    v: string;
    n: number;
}
